<tds-type-ahead
  [id]="id"
  [label]="label"
  [placeholder]="'search_detailed_placeholder' | translate"
  [control]="control"
  [typeahead]="search"
  [loading]="loading"
  [item_not_found]="no_results_found"
  [result_format]="result_format"
  [input_format]="input_format"
  [editable]="false"
  [input_required_translation]="'input_is_required' | translate : label"
  [no_results_found_translation]="'no_results_found' | translate"
  [loading_translation]="'loading' | translate"
  (selectItem)="onSelectApprover($event)"
/>
